export default __webpack_public_path__ + "static/media/pencil.17725857.svg";